<template>
  <div id="url_valid">
    <div style="text-align: center;">
      <div><h4>Welcome {{userDetails.first_name}}<br>({{userDetails.mobile}})</h4></div>
      <div>{{userDetails.address}}</div>
      *****<br>
      <div id="not_subscribed">
        Payment Type : {{subscriptionType}}<br>
        Start Date : {{userDetails.displayedStartDate}}<br><br></i>
        <i>Delivery Schedule :</i><br>
        <input type="radio" id="everyday" value="3" v-model="deliveryFrequency">
        <label for="everyday">Everyday</label>&nbsp;
        <input type="radio" id="alternate" value="2" v-model="deliveryFrequency">
        <label for="alternate">Alternate</label><br><br>
        <i>Quantity :</i><br>
        <input type="radio" id="one" value="1" v-model="quantity">
        <label for="one">1 litre</label>&nbsp;
        <input type="radio" id="two" value="2" v-model="quantity">
        <label for="two">2 litre</label>&nbsp;
        <input type="radio" id="three" value="3" v-model="quantity">
        <label for="three">3 litre  </label><br><br>
        <div class="w3-center">
          <form>
            <input class="subs" value="SUBSCRIBE NOW" type="button" v-on:click="subscribe();">
          </form>
        </div>
      </div>
      <div id="subscribed">
        Successfully Subscribed. Your delivery will start from {{userDetails.displayedStartDate}}<br>
        <a v-bind:href="subscriptionObj.paymentUrl">Click</a> to Pay<br><br>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        subscriptionType: 'Postpaid',
        deliveryFrequency: 3,
        quantity: 1,
        productId: 1,
        type: 'Daily',
        alternate: 2, // fix for every second day in alternate
        userDetails: [],
        subscriptionObj: []
      }
    },
    created () {
      if (sessionStorage.getItem('userId') === null) {
        this.$router.push('/a/reg')
      } else {
        this.userInfo()
      }
      // this.userInfo()
    },
    methods: {
      userInfo () {
        const params = new URLSearchParams()
        var userId = sessionStorage.getItem('userId')
        params.append('user_id', userId)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          document.getElementById('subscribed').style.display = 'none'
          document.getElementById('not_subscribed').style.display = 'block'
          this.userDetails = {}
          this.userDetails.userId = userId
          this.userDetails.first_name = response.data.user_record.user_details.first_name
          this.userDetails.mobile = response.data.user_record.user.username
          this.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city
          this.userDetails.startDate = response.data.today_date
          this.userDetails.displayedStartDate = this.userDetails.startDate.split('-').reverse().join('-')
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      subscribe () {
        const params = new URLSearchParams()
        params.append('user_id', sessionStorage.getItem('userId'))
        params.append('product_id', this.productId)
        params.append('start_date', this.userDetails.startDate)
        params.append('type', this.type)
        params.append('delivery_frequency', this.deliveryFrequency)
        params.append('subscription_type', this.subscriptionType)
        params.append('quantity', this.quantity)
        params.append('alternate', this.alternate)
        axios({
          url: process.env.BASE_API + '/subscriptions/add',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.subscriptionObj = {}
          if (response.data.status === '000000') {
            this.subscriptionObj.paymentUrl = response.data.payment_url
            document.getElementById('subscribed').style.display = 'block'
            document.getElementById('not_subscribed').style.display = 'none'
          } else {
            alert(response.data.msg)
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      }
    }
  }
</script>
<style>
.subs {background-color: #3CB6C3; padding: 2% 17% 2% 18%;}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Subscription.vue